export function shouldUpdateChunkHeight(previousBets, bets) {
    if (typeof previousBets === "undefined") {
        return true;
    }
    return bets.some((bet, index) => {
        var _a, _b;
        if (typeof previousBets[index] === "undefined") {
            return true;
        }
        return ((_a = bet.cashOut) === null || _a === void 0 ? void 0 : _a.status) !== ((_b = previousBets[index].cashOut) === null || _b === void 0 ? void 0 : _b.status)
            || bet.isExpanded !== previousBets[index].isExpanded;
    });
}
//# sourceMappingURL=shouldUpdateChunkHeight.js.map